import React from "react";
import "./alerts_cms.scss";
import Cookie from "js-cookie";

const Alerts_Cms = ({ alertCount = 0, onClick }) => {
  const hasAlerts = alertCount > 0;
  const theme = Cookie.get("theme"); 

  const displayCount =
    alertCount > 9 ? "9+" : alertCount;

  return (
    <button
      className="alerts-btn"
      aria-label="Alerts"
      onClick={onClick}
    > 

        <img
          src="/alerts_cms.svg"
          alt="alerts"
          
          className="alerts-icon"
        />

      {hasAlerts && (
        <span className="alerts-count">
          {displayCount}
        </span>
      )}
    </button>
  );
};

export default Alerts_Cms;
